import { DownloadIcon } from '@heroicons/react/outline';
import { Button } from '@mosey/components/buttons/Button';

interface DocumentPreviewPanelProps {
  typeName?: string;
  issueDate?: string;
  downloadUrl: string;
  onDownloadClick: () => void;
}

export const DocumentPreviewPanel = ({
  typeName,
  issueDate,
  downloadUrl,
  onDownloadClick,
}: DocumentPreviewPanelProps) => {
  return (
    <div className="flex h-full grow flex-col">
      <div className="flex min-h-[70px] items-center justify-between gap-4 border-b py-4">
        <div className="mb-2">
          {typeName && <h2 className="text-xl font-semibold">{typeName}</h2>}

          {issueDate && (
            <p className="text-sm leading-6 text-gray-400">
              {`Issued ${issueDate}`}
            </p>
          )}
        </div>

        <div className="ml-auto flex items-center gap-2">
          <Button
            size="small"
            variant="secondary"
            onClick={onDownloadClick}
            isFullWidth
            rightIcon={<DownloadIcon className="ml-2 w-4" />}
          >
            Download
          </Button>
        </div>
      </div>

      <div className="flex grow flex-col border-l">
        <iframe
          src={`${downloadUrl}#toolbar=0`}
          title={typeName || 'Document Preview'}
          className="w-full flex-1"
          allow="fullscreen"
        />
      </div>
    </div>
  );
};
